import { render } from "./SchoolServiceDailyContianer.vue?vue&type=template&id=007c85d6&scoped=true&ts=true"
import script from "./SchoolServiceDailyContianer.vue?vue&type=script&lang=ts"
export * from "./SchoolServiceDailyContianer.vue?vue&type=script&lang=ts"

import "./SchoolServiceDailyContianer.vue?vue&type=style&index=0&id=007c85d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007c85d6"]])

export default __exports__